import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from '@app/auth/auth-guard.service';

import {MainComponent} from './main/main.component';

const routes: Routes = [
    { path: 's/', component: MainComponent, canActivate: [AuthGuardService] },
    { path: 's/:streamId', component: MainComponent, canActivate: [AuthGuardService] },
    { path: 'l/:linkId', component: MainComponent, canActivate: [AuthGuardService] },
    { path: 'v/:assetId', component: MainComponent, canActivate: [AuthGuardService] },
    { path: 'v/:streamId/:assetId', component: MainComponent, canActivate: [AuthGuardService] },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MainRoutingModule {}
